<template>
  <div>
    <section class="box" v-if="datas">

      <!-- 焦点图 -->
      <div class="swiper-container banner">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
            v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img">
          </div>
        </div>
        <div class="swiper-pagination"></div> 
      </div>

      <div class="main-box">
        <div class="card-box p20">
          <div class="input-box">防伪密码：{{code}}</div>
          <div class="btn-box">
            <div class="btn" @click="checkHandle">立即查询</div>
          </div>
          <div v-if="!isCheck" class="tips">
            请点击【<span>立即查询</span>】按钮获取当前产品防伪验证信息
          </div>
          <template v-else>
            <div class="tips">产品编码：{{ datas.verify || datas.product.production_id }}</div>
            <div class="return-success" v-if="datas.scan_count <= 1">{{successMsg}}</div>
            <div class="return-error" v-else>{{ errorMsg }}</div>
          </template>
        </div>


        <div class="card-box p10" v-if="datas.ref && datas.ref_is_show == 1">
          <div class="tabs">
            <div class="title" :class="{ac: tabIndex == 0}" @click="tabIndex=0">
              <img class="icon" :src="`/static/images/Normal26/${tabIcons['产品信息']}${tabIndex == 0?'_a':''}.png`" />
              <p class="tit">产品信息</p>
            </div>
            <div class="title" :class="{ac: tabIndex == (index+1)}" v-for="(item,index) in datas.ref" :key="index" @click="tabIndex=(index+1)">
              <img class="icon" :src="`/static/images/Normal26/${tabIcons[item.name]}${tabIndex == (index+1)?'_a':''}.png`" />
              <p class="tit">{{item.name}}</p>
            </div>
          </div>

          <!-- 产品列表 -->
          <div class="product" v-show="datas.product && datas.prod_is_show == 1 && tabIndex == 0">
            <ul class="form">
              <li><img v-show="isCheck" class="img" :src="datas.product.img" /></li>
              <li class="row">产品名称：{{ isCheck?datas.product.name:'' }}</li>
              <li class="row" v-for="val in datas.product.attribute">{{val.key}}：{{ isCheck?val.value:'' }}</li>
            </ul>
          </div>

          <!-- 其它列表 -->
          <div class="ref" v-show="tabIndex > 0">
            <ul class="list" v-if="datas.ref[tabIndex-1] && datas.ref[tabIndex-1].datas">
              <li v-for="(val,ix) in datas.ref[tabIndex-1].datas" v-bind:key="ix">
                <a v-if="val.type == 0" v-text="val.data"></a>
                <img class="img" v-else :src="val.data">
              </li>
            </ul>
          </div>
        </div>

      </div>

      <!-- 底部菜单 -->
      <div v-if="datas.menu && datas.menu.length && datas.menu_is_show == 1">
        <div style="height: 70px;"></div>
        <ul class="menu">
          <li class="row" v-for="(item, index) in datas.menu" :class="{ac: menuIndex == index}" :key="index" @click="menuClick(item)">
            <p class="icon-box">
              <img class="icon" v-if="item.icon" :src="item.icon" />
            </p>
            <p class="title">{{item.name}}</p>
          </li>
        </ul>
      </div>

    </section>

    <!-- 创建一个隐藏的audio元素 -->
    <audio id="audioPlayer" style="display: none;"></audio>
    
    <K-AlertMsg :AlertMsg="AlertMsg" bg="#8bbd21" @AlertBack="AlertBack"></K-AlertMsg>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Speaker from '../hook/auto.js'
import mixin from '../mixins/mixin.js'
import { formatDate } from '@/hook/common.js'
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
export default {
  name: 'Normal26',
  mixins: [mixin],
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      audioSrc: '',
      tabIndex: 0,
      menuIndex: 0,
      isCheck: false,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      tabIcons: {
        '产品信息': 'cp',
        '溯源信息': 'sy',
        '产品系列': 'xl',
      }
    }
  },
  created() {
    self = this;
    this.AdaptiveSizeNew();
    document.body.style.backgroundColor = "#f6f6ee";
    document.title = "防伪查询";  //设置页面标题

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  computed:{
    successMsg(){
      return this.datas.first_antifake_msg || '尊敬的用户，您查询的商品为正品，请放心使用！'
    },
    errorMsg(){
      return this.datas.many_antifake_msg|| '尊敬的用户，您所查询的条码已失效！';
    },
  },
  methods: {
    checkHandle(){
      if(!this.isCheck){
        this.isCheck = true;
        this.playAudio();
        sessionStorage.setItem(`wwm_code_${this.code}`, true);
      }
    },
    menuClick(item){
      if(item.url){
        this.skipLink(item.url);
      }
    },
    playAudio(){
      const audioPlayer = document.getElementById('audioPlayer');
      let msg = this.datas.scan_count <= 1?this.successMsg: this.errorMsg;
      audioPlayer.src = this.GetServerUrl(1) + `getVoice?text=${msg}`;
      audioPlayer.load();  // 加载音频文件
      audioPlayer.play();  // 播放音频
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.query_count = response.data.meta.query_count;  //查询次数
          datas.query_first_time = response.data.meta.query_first_time;  //查询时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.code = self.code; //二维码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;
          self.isCheck = sessionStorage.getItem(`wwm_code_${self.code}`)?true:false;

          setTimeout(() => {
            new Swiper('.banner', {
              autoplay: {
                delay: 5000
              },//可选选项，自动滑动
              loop: true, //可选选项，开启循环
              pagination: {
                el: '.swiper-pagination',
                bulletActiveClass : 'Normal26-banner-active',
              }
            }) 
          });

        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>
<style scoped lang="scss">
.p10{
  padding: 15px;
}
.p20{
  padding: 25px;
}
.box{
  font-size: 16px;
  .banner{
    img{
      width: 100%;
      display: block;
    }
  }

  .main-box{
    padding: 0 10px;
    .input-box{
      width: 100%;
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0px 0px 10px #dcdcdc inset;
    }
    .btn-box{
      display: flex;
      padding: 30px 0;
      flex-direction: row;
      justify-content: center;
    }
    .btn{
      color: #FFFFFF;
      font-size: 19px;
      display: inline-block;
      width: 60%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background: url(/static/images/Normal26/btn-bg.jpg) repeat-x;
      background-size: 100% 100%;
      border-radius: 5px;
      box-shadow: 2px 2px 10px #3EBA7A;
    }
    .tips,.return-success,.return-error{
      padding: 12px 0;
      border-top: 1px dashed #030303;
      span{
        color: #42bc91;
      }
    }
    .return-success{
      color: #659a64;
      font-weight: bold;
    }
    .return-error{
      color: red;
      font-weight: bold;
    }
  }

  .tabs{
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    margin-top: 15px;
    .title{
      width: 33%;
      gap: 5px;
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      text-align: center;
      height: 45px;
      align-items: center;
      line-height: 45px;
      color: #0075b5;
      background: url(/static/images/Normal26/tab-bg.jpg) repeat-x;
      background-size: 100% 100%;
      box-shadow: 2px 2px 10px #c7edff;
      border-left: 1.2px solid #028c92;
      border-right: 1.2px solid #028c92;
      
      &:first-child{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: 1px solid #028c92;
        border-right: none;
      }
      &:last-child{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-left: none;
        border-right: 1px solid #028c92;
      }
      
      .icon{
        width: 20px;
        height: 20px;
      }
      .tit{
        text-align: center;
      }
    }
    .ac{
      color: white;
      background: url(/static/images/Normal26/tab-bg-ac.jpg) repeat-x;
    }
  }

  .card-box{
    margin: 20px 0;
    border-radius: 20px;
    background-color: white;
    box-shadow: 2px 2px 17px #BFBFBF;
  }

  .product{
    margin-top: 20px;
    .form{
      .row{
        margin-top: 10px;
        font-size: 15px;
        padding: 7px 3px;
        border-bottom: 1px solid #999999;
      }
    }
  }

  .ref{
    margin-top: 20px;
  }
  
  .img{
    width: 100%;
    display: block;
  }

  .menu{
    position: fixed;
    left: 0;right: 0;
    bottom: 0;
    z-index: 99;
    height: 60px;
    display: flex;
    flex-direction: row;
    background: url(/static/images/Normal26/menu-bg.jpg) repeat-x;
    box-shadow: 0 0 1px rgba(0,0,0,.85);
    background-size: 100% 100%;

    .row{
      flex: 1;
      color: #000000;
      text-align: center;
    }

    .ac{
      color: #FFFFFF;
      background: url(/static/images/Normal26/menu-bg-ac.jpg) repeat-x;
      background-size: 100% 100%;
    }

    .icon-box{
      width: 25px;
      height: 25px;
      display: block;
      margin: auto;
      margin-top: 8px;
      .icon{
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .title{
      line-height: 1;
      font-size: 16px;
      margin-top: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Normal26.vue